import { LOGIN_USER_SUCCESS, LOGIN_USER_FAILURE, LOGIN_USER, REGISTER_USER_SUCCESS, REGISTER_USER_FAILURE, REGISTER_USER } from '../actions/auth';
import { call, put, takeLatest } from 'redux-saga/effects';
import { login, register } from "../api/auth";
import {handleActions} from "redux-actions";

function* onLoginAsync(action) {
    try {
        const response = yield call(login, action.payload);
        if (response.status === 200) {
            yield put({ type: LOGIN_USER_SUCCESS, payload: response });
        }
    } catch (e) {
        yield put({ type: LOGIN_USER_FAILURE, payload: e });
    }
}

function* onRegisterAsync(action) {
    try {
        const response = yield call(register, action.payload);
        if (response.status === 200) {
            yield put({ type: REGISTER_USER_SUCCESS, payload: response });
        }
    } catch (e) {
        yield put({ type: REGISTER_USER_FAILURE, payload: e });
    }
}

function onRegisterSuccess(action) {
    window.location.href = '/completed';
}

const initialState = {
    isAuthenticated: false,
    token: null,
    error: null,
};

export function* authSaga() {
    yield takeLatest(LOGIN_USER, onLoginAsync);
    yield takeLatest(REGISTER_USER, onRegisterAsync);
    yield takeLatest(REGISTER_USER_SUCCESS, onRegisterSuccess);
}

export default handleActions(
    {
        [LOGIN_USER_SUCCESS]: (state, action) => {
            return {
                ...state,
                isAuthenticated: true,
                token: action.payload.data,
                error: null
            };
        },
        [LOGIN_USER_FAILURE]: (state, action) => {
            const { message } = action.payload.response.data;
            return {
                ...state,
                isAuthenticated: false,
                token: null,
                error: message
            };
        },
        [REGISTER_USER_SUCCESS]: (state, action) => {
            return {
                ...state,
                isAuthenticated: false,
                token: null,
                error: null
            };
        },
        [REGISTER_USER_FAILURE]: (state, action) => {
            const { message } = action.payload.response.data;
            return {
                ...state,
                isAuthenticated: false,
                token: null,
                error: message
            };
        },
    },
    initialState
);